import React from 'react';

function ShuTongCharacter({ className = '' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 80 96"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <ellipse cx="40" cy="92" rx="22" ry="4" fill="rgba(0,0,0,0.12)" />

      <path
        d="M22 58c2 18 12 28 18 28s16-10 18-28c2-14 0-26-8-32-6-4-14-4-20 0-8 6-10 18-8 32z"
        fill="#c0392b"
      />
      <path
        d="M40 86c-6 0-14-8-16-22l4-2c2 10 8 16 12 16s10-6 12-16l4 2c-2 14-10 22-16 22z"
        fill="#8a1a1a"
      />
      <rect x="34" y="52" width="12" height="14" rx="2" fill="#f5d76e" />

      <circle cx="40" cy="34" r="18" fill="#ffe8c8" />
      <ellipse cx="40" cy="22" rx="14" ry="8" fill="#2c1810" />
      <circle cx="40" cy="18" r="6" fill="#2c1810" />
      <ellipse cx="28" cy="26" rx="4" ry="7" fill="#2c1810" transform="rotate(-20 28 26)" />
      <ellipse cx="52" cy="26" rx="4" ry="7" fill="#2c1810" transform="rotate(20 52 26)" />

      <ellipse cx="33" cy="35" rx="2.5" ry="3" fill="#2c1810" />
      <ellipse cx="47" cy="35" rx="2.5" ry="3" fill="#2c1810" />
      <circle cx="34" cy="33" r="1" fill="#fff" opacity="0.7" />
      <circle cx="48" cy="33" r="1" fill="#fff" opacity="0.7" />
      <path d="M36 42 Q40 45 44 42" stroke="#c0392b" strokeWidth="1.5" fill="none" strokeLinecap="round" />
      <ellipse cx="30" cy="40" rx="4" ry="2.5" fill="#ffb4a2" opacity="0.5" />
      <ellipse cx="50" cy="40" rx="4" ry="2.5" fill="#ffb4a2" opacity="0.5" />

      <path
        d="M18 48 L14 62 L20 60 L22 48 Z"
        fill="#c0392b"
      />
      <path
        d="M62 48 L66 62 L60 60 L58 48 Z"
        fill="#c0392b"
      />

      <rect x="48" y="44" width="18" height="22" rx="2" fill="#f5e6c8" stroke="#8a6d3b" strokeWidth="1.2" />
      <line x1="52" y1="50" x2="62" y2="50" stroke="#8a6d3b" strokeWidth="0.8" opacity="0.6" />
      <line x1="52" y1="54" x2="62" y2="54" stroke="#8a6d3b" strokeWidth="0.8" opacity="0.6" />
      <line x1="52" y1="58" x2="60" y2="58" stroke="#8a6d3b" strokeWidth="0.8" opacity="0.6" />
      <path d="M48 44 L57 44 L57 38 Q52 36 48 40 Z" fill="#d6a84f" />

      <path
        d="M26 30 Q20 24 22 18"
        stroke="#2c1810"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default ShuTongCharacter;
